export const environment = {
    production: false,
    protect: true,
    MAPS_API_KEY: 'AIzaSyBbsgvrQ348Ls8lLGU8WitdzSBtBbUCao4' 
};
